import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import '../../../App.css';

import { ReservationPMSDetails, SaveResAgentdetail } from '../../Services/Service';
import ReservationSidebar from '../Commun/ReservationSidebar';
import ReservationHeader from '../Commun/ReservationHeader';
import { useProperty } from '../../PropertyContext';

const ReservationNewAgent = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { selectedProperty } = useProperty();
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [results, setResults] = useState([]);
    const agentData = location.state?.agentData || null;

    const [formData, setFormData] = useState({
        AgentID: 0,
        Email: '',
        Password: '',
        FirstName: '',
        MidlleName: '',
        LastName: '',
        DOB: '',
        Gender: '',
        Address: '',
        City: '',
        State: '',
        Country: '',
        PinCode: '',
        TA_Name: '',
        Website: '',
        MobileNo: '',
        TelNo: '',
        TelEx: '',
        Gst: '',
        Pan: '',
        PMSCode: '',
        MarketSegment: '',
        BusinessSource: '',
        BillingInstructions: '',
        AgentCode: '',
        IsPushMealPlan: 0,
        MaxRoomBook: 0,
    });

    useEffect(() => {
        if (agentData) {
            setFormData((prev) => ({ ...prev, ...agentData }));
        }
    }, [agentData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        setLoading(true);
        e.preventDefault();
        const isEdit = !!formData.AgentID;

        const payload = {
            ...formData,
            Hotel: localStorage.getItem("selectedPropertyID") || "0",
            AgentID: formData.AgentID || 0,
            Status: 1,
            CreatedBy: null,
            ModifyBY: null,
            CreatedDateTime: new Date().toISOString(),
            ModifyDateTime: new Date().toISOString(),
            AgentCode: formData.AgentCode || "AGENT-" + Date.now(),
            AgencyLogo: "",
            AccountManager: "2",
            IsPushMealPlan: formData.IsPushMealPlan,
            MaxRoomBook: formData.MaxRoomBook,
            OperaProfileID: formData.ProfileID || null
        };

        try {
            const result = await SaveResAgentdetail(payload, selectedProperty?.PropertyID);
            console.log(result);
            navigate("/Reservation/AgentList", {
                state: { success: isEdit ? "Agent Updated Successfully" : "Agent Registered Successfully" }
            });
        } catch (error) {
            console.error("Agent not saved:", error);
            alert("Something went wrong!");
        } finally {
            setLoading(false);
        }
    };


    const handlePMSDetailSearch = async (e) => {
        e.preventDefault();
        if (!searchTerm.trim()) return;

        try {
            setLoading(true);

            const res = await ReservationPMSDetails(searchTerm, "agent", selectedProperty?.PropertyID); // passing Name + ProfileType

            const profiles = res?.Result?.profileSummaries?.profileInfo || [];
            setResults(profiles);
        } catch (error) {
            console.error("Search error:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const modal = document.querySelector(".bs-example-modal-lg");

        const handleModalClose = () => {
            setSearchTerm("");  // input reset
            setResults([]);    // results reset
        };

        if (modal) {
            modal.addEventListener("hidden.bs.modal", handleModalClose);
        }

        return () => {
            if (modal) {
                modal.removeEventListener("hidden.bs.modal", handleModalClose);
            }
        };
    }, []);


    const handleSelectAgent = (agent) => {
        const profile = agent.profile;
        const profileIdObj = agent.profileIdList?.[0] || {};

        setFormData((prev) => ({
            ...prev,
            TA_Name: profile.formerName?.name || "",
            Address: profile.addressInfo?.address?.addressLine?.filter(Boolean).join(", ") || "",
            City: profile.addressInfo?.address?.cityName || "",
            State: profile.addressInfo?.address?.state || "",
            Country: profile.addressInfo?.address?.country?.value || "",
            PinCode: profile.addressInfo?.address?.postalCode || "",
            ProfileID: profileIdObj.id || "",
            ProfileType: profileIdObj.type || ""
        }));

        // Modal close karne ke liye bootstrap modal method
        const modal = document.querySelector(".bs-example-modal-lg");
        if (modal) {
            const bootstrapModal = window.bootstrap.Modal.getInstance(modal);
            bootstrapModal.hide();
        }
    };



    return (
        <>
            {loading && (
                <div className="fullscreen-loader">
                    <div className="fas fa-spinner fa-spin fa-3x " role="status"></div>
                </div>
            )}

            <div className="wrapper">
                <ReservationSidebar />
                <div className="main-panel">
                    <ReservationHeader />
                    <div className="container">
                        <div className="page-inner">

                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card">
                                        <div className="card-header">
                                            <div className="card-title">{formData.AgentID ? "Edit Agent" : "Agent Registration"}</div>
                                        </div>
                                        <div className="card-body">
                                            <form onSubmit={handleSubmit}>
                                                <div className="row">
                                                    {/* Name of Agency/Operator */}
                                                    <div className="col-md-4">
                                                        <div className="input-block mb-3">
                                                            <label className="col-form-label">Name of The Agency/Operator</label>
                                                            <div className='d-flex'>
                                                                <input type="text" name="TA_Name" className="form-control"
                                                                    value={formData.TA_Name || ""}
                                                                    onChange={handleChange}
                                                                    placeholder="Name of The Agency/Operator"
                                                                />
                                                                <button type="button" class="btn btn-primary btn-sm mx-2 " data-bs-toggle="modal" data-bs-target=".bs-example-modal-lg"><i className='fas fa-search'></i></button>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Address */}
                                                    <div className="col-md-8">
                                                        <div className="input-block mb-3">
                                                            <label className="col-form-label">Address</label>
                                                            <textarea
                                                                type="text"
                                                                name="Address"
                                                                rows="2"
                                                                className="form-control"
                                                                value={formData.Address || ""}
                                                                onChange={handleChange}
                                                                placeholder="Address"
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* State */}
                                                    <div className="col-md-4">
                                                        <div className="input-block mb-3">
                                                            <label className="col-form-label">State</label>
                                                            <input
                                                                type="text"
                                                                name="State"
                                                                className="form-control"
                                                                value={formData.State || ""}
                                                                onChange={handleChange}
                                                                placeholder="State"
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Country */}
                                                    <div className="col-md-4">
                                                        <div className="input-block mb-3">
                                                            <label className="col-form-label">Country</label>
                                                            <input
                                                                type="text"
                                                                name="Country"
                                                                className="form-control"
                                                                value={formData.Country || ""}
                                                                onChange={handleChange}
                                                                placeholder="Country"
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* City */}
                                                    <div className="col-md-4">
                                                        <div className="input-block mb-3">
                                                            <label className="col-form-label">City</label>
                                                            <input
                                                                type="text"
                                                                name="City"
                                                                className="form-control"
                                                                value={formData.City || ""}
                                                                onChange={handleChange}
                                                                placeholder="City"

                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Pin Code */}
                                                    <div className="col-md-4">
                                                        <div className="input-block mb-3">
                                                            <label className="col-form-label">Pin Code</label>
                                                            <input
                                                                type="number"
                                                                name="PinCode"
                                                                className="form-control"
                                                                value={formData.PinCode || ""}
                                                                onChange={handleChange}
                                                                placeholder="Pin Code"
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Website */}
                                                    <div className="col-md-4">
                                                        <div className="input-block mb-3">
                                                            <label className="col-form-label">Agency/Operator Website</label>
                                                            <input
                                                                type="text"
                                                                name="Website"
                                                                className="form-control"
                                                                value={formData.Website || ""}
                                                                onChange={handleChange}
                                                                placeholder="Website"

                                                            />
                                                        </div>
                                                    </div>

                                                    {/* First Name */}
                                                    <div className="col-md-4">
                                                        <div className="input-block mb-3">
                                                            <label className="col-form-label">Contact Person First Name</label>
                                                            <input
                                                                type="text"
                                                                name="FirstName"
                                                                className="form-control"
                                                                value={formData.FirstName || ""}
                                                                onChange={handleChange}
                                                                placeholder="First Name"

                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Middle Name */}
                                                    <div className="col-md-4">
                                                        <div className="input-block mb-3">
                                                            <label className="col-form-label">Middle Name</label>
                                                            <input
                                                                type="text"
                                                                name="MidlleName"
                                                                className="form-control"
                                                                value={formData.MidlleName || ""}
                                                                onChange={handleChange}
                                                                placeholder="Middle Name"
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Last Name */}
                                                    <div className="col-md-4">
                                                        <div className="input-block mb-3">
                                                            <label className="col-form-label">Last Name</label>
                                                            <input
                                                                type="text"
                                                                name="LastName"
                                                                className="form-control"
                                                                value={formData.LastName || ""}
                                                                onChange={handleChange}
                                                                placeholder="Last Name"

                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Mobile Number */}
                                                    <div className="col-md-4">
                                                        <div className="input-block mb-3">
                                                            <label className="col-form-label">Mobile Number</label>
                                                            <input
                                                                type="number"
                                                                name="MobileNo"
                                                                className="form-control"
                                                                value={formData.MobileNo || ""}
                                                                onChange={handleChange}
                                                                placeholder="Mobile Number"

                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Telephone Number */}
                                                    <div className="col-md-4">
                                                        <div className="input-block mb-3">
                                                            <label className="col-form-label">Telephone Number</label>
                                                            <input
                                                                type="text"
                                                                name="TelNo"
                                                                className="form-control"
                                                                value={formData.TelNo || ""}
                                                                onChange={handleChange}
                                                                placeholder="Telephone Number"
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Telephone Extension */}
                                                    <div className="col-md-4">
                                                        <div className="input-block mb-3">
                                                            <label className="col-form-label">Telephone Extension</label>
                                                            <input
                                                                type="text"
                                                                name="TelEx"
                                                                className="form-control"
                                                                value={formData.TelEx || ""}
                                                                onChange={handleChange}
                                                                placeholder="Telephone Extension"
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Date of Birth */}
                                                    <div className="col-md-4">
                                                        <div className="input-block mb-3">
                                                            <label className="col-form-label">Date of Birth</label>
                                                            <input type="date" name="DOB" className="form-control" value={formData.DOB || ""} onChange={handleChange} />
                                                        </div>
                                                    </div>

                                                    {/* Email */}
                                                    <div className="col-md-4">
                                                        <div className="input-block mb-3">
                                                            <label className="col-form-label">Email</label>
                                                            <input type="email" name="Email" className="form-control" value={formData.Email || ""} onChange={handleChange} placeholder="Email" />
                                                        </div>
                                                    </div>

                                                    {/* Password */}
                                                    <div className="col-md-4">
                                                        <div className="input-block mb-3">
                                                            <label className="col-form-label">Password</label>
                                                            <input type="password" name="Password" className="form-control" value={formData.Password || ""} onChange={handleChange} placeholder="Password" />
                                                        </div>
                                                    </div>

                                                    {/* GST Number */}
                                                    <div className="col-md-4">
                                                        <div className="input-block mb-3">
                                                            <label className="col-form-label">GST Number</label>
                                                            <input type="text" name="Gst" className="form-control" value={formData.Gst || ""} onChange={handleChange} placeholder="GST Number" />
                                                        </div>
                                                    </div>

                                                    {/* PAN Number */}
                                                    <div className="col-md-4">
                                                        <div className="input-block mb-3">
                                                            <label className="col-form-label">PAN Number</label>
                                                            <input type="text" name="Pan" className="form-control" value={formData.Pan || ""} onChange={handleChange} placeholder="PAN Number" />
                                                        </div>
                                                    </div>

                                                    {/* PMS Code */}
                                                    <div className="col-md-4">
                                                        <div className="input-block mb-3">
                                                            <label className="col-form-label">PMS Code</label>
                                                            <input type="text" name="PMSCode" className="form-control" value={formData.PMSCode || ""} onChange={handleChange} placeholder="PMS Code" />
                                                        </div>
                                                    </div>

                                                    {/* Gender Dropdown */}
                                                    <div className="col-md-4">
                                                        <div className="input-block mb-3">
                                                            <label className="col-form-label">Gender</label>
                                                            <select className="form-control form-select" name="Gender" value={formData.Gender || ""} onChange={handleChange}>
                                                                <option value="">Select Gender</option>
                                                                <option value="Male">Male</option>
                                                                <option value="Female">Female</option>
                                                                <option value="Other">Other</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    {/* Market Segment Dropdown */}
                                                    <div className="col-md-4">
                                                        <div className="input-block mb-3">
                                                            <label className="col-form-label">Market Segment</label>
                                                            <select className="form-control form-select" name="MarketSegment" value={formData.MarketSegment || ""} onChange={handleChange}>
                                                                <option value="">Select Market Segment</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    {/* Business Source Dropdown */}
                                                    <div className="col-md-4">
                                                        <div className="input-block mb-3">
                                                            <label className="col-form-label">Business Source</label>
                                                            <select className="form-control form-select" name="BusinessSource" value={formData.BusinessSource || ""} onChange={handleChange}>
                                                                <option value="">Select Business Source</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    {/* Billing Instructions Dropdown */}
                                                    <div className="col-md-4">
                                                        <div className="input-block mb-3">
                                                            <label className="col-form-label">Billing Instructions</label>
                                                            <select className="form-control form-select" name="BillingInstructions" value={formData.BillingInstructions || ""} onChange={handleChange} >
                                                                <option value="">Select Billing Instructions</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-3'>
                                                        <div className="input-block mb-3">
                                                            <label className="col-form-label">Maximum Room Can book</label>
                                                            <input type='number' className='form-control' name='MaxRoomBook' value={formData.MaxRoomBook} onChange={handleChange} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <div className="input-block mb-3">
                                                            <label className="col-form-label">Meal Plan send</label>
                                                            <div className='d-flex gap-2'>
                                                                <input type='radio' name="IsPushMealPlan"
                                                                    value={1}
                                                                    checked={formData.IsPushMealPlan === 1}
                                                                    onChange={(e) =>
                                                                        setFormData((prev) => ({
                                                                            ...prev,
                                                                            IsPushMealPlan: Number(e.target.value)
                                                                        }))
                                                                    } />
                                                                <label className='form-label mt-1 me-4'>Yes</label>

                                                                <input type='radio' name="IsPushMealPlan"
                                                                    value={0}
                                                                    checked={formData.IsPushMealPlan === 0}
                                                                    onChange={(e) =>
                                                                        setFormData((prev) => ({
                                                                            ...prev,
                                                                            IsPushMealPlan: Number(e.target.value)
                                                                        }))
                                                                    } />
                                                                <label className='form-label mt-1'>No</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="card-action text-end">
                                                    <button type="submit" className="btn btn-primary">
                                                        {formData.AgentID ? "Update Agent" : "Register Now"}
                                                    </button>
                                                </div>
                                            </form>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <>
                            {/*  Large modal example */}
                            <div
                                className="modal fade bs-example-modal-lg"
                                tabIndex={-1}
                                role="dialog"
                                aria-labelledby="myLargeModalLabel"
                                aria-hidden="true"
                            >
                                <div className="modal-dialog modal-lg">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title" id="myLargeModalLabel">
                                                Search Agent
                                            </h5>
                                            <button
                                                type="button"
                                                className="btn-close"
                                                data-bs-dismiss="modal"
                                                aria-label="Close"
                                            ></button>
                                        </div>
                                        <div className="modal-body">
                                            <div className='row'>
                                                <div className='col-ms-12'>
                                                    <form className='row' onSubmit={handlePMSDetailSearch}>
                                                        <div className='col-md-4'>
                                                            <div className='mb-3'>
                                                                <input type='text' className='form-control' placeholder="Search here..." value={searchTerm}
                                                                    onChange={(e) => setSearchTerm(e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className='col-md-1'>
                                                            <div className='mb-3'>
                                                                <button type='submit' className='btn btn-primary '>Search</button>
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>

                                            <div className='row'>
                                                <div className='col-md-12'>

                                                    <div className='table-responsive'>
                                                        <table className='table '>
                                                            <thead>
                                                                <tr>
                                                                    <th>Sr #</th>
                                                                    <th>Name</th>
                                                                    <th>Action</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {results.length > 0 ? (
                                                                    results.map((item, index) => (
                                                                        <tr key={item.profileIdList?.[0]?.id || index}>
                                                                            <td>{index + 1}</td>
                                                                            <td>{item.profile?.formerName?.fullName}</td>
                                                                            <td>
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-sm btn-primary"
                                                                                    onClick={() => handleSelectAgent(item)}
                                                                                >
                                                                                    Select
                                                                                </button>
                                                                            </td>
                                                                        </tr>
                                                                    ))
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan="3" className="text-center">
                                                                            {loading
                                                                                ? "Searching..."
                                                                                : "No results. Please search other agent."}
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    {/* /.modal-content */}
                                </div>
                                {/* /.modal-dialog */}
                            </div>
                            {/* /.modal */}
                        </>

                    </div>

                </div>
            </div >
        </>
    );
};

export default ReservationNewAgent;
